(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[1526],{

/***/ 91995:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Y": function() { return /* binding */ LogoText; }
/* harmony export */ });
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(67294);
function _defineProperty(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _defineProperty(target, key, source[key]);
        });
    }
    return target;
}


var LogoText = function(props) {
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("svg", _objectSpread({
        viewBox: "0 0 712.086 98.201",
        xmlns: "http://www.w3.org/2000/svg"
    }, props, {
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("defs", {}),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("path", {
                className: "a",
                d: "M513.391 1.999h13.812v41.566a44.654 44.654 0 008.289.5c16.45 0 27.627-10.422 27.627-28 0-4.394-.127-9.794-.378-14.063h13.814c.252 4.521.376 9.418.376 13.562 0 18.835-8.79 32.148-24.236 37.923l28.507 42.7h-16.829l-26.12-39.807c-1.381.125-2.761.125-4.144.125a63.517 63.517 0 01-6.906-.376v40.058h-13.814zM189.311 2.009h54v12.054h-40.186V42.57h37.673V54.5h-37.673v29.511h40.81v12.181h-54.627zM288.428 2.009h17.831l31.4 94.184h-14.818l-7.409-23.735h-36.544l-7.534 23.735h-14.315zm-5.652 58.268h28.758l-14.065-44.706h-.5zM361.373 14.063h-25.115V2.009h64.044v12.054h-25.115v82.129h-13.814zM601.85 2.009h13.812v94.184H601.85zM67.645 80.668a37.288 37.288 0 01-18.161 4.565c-9.528 0-17.958-3.6-25.055-10.694a35.6 35.6 0 010-50.877c7.1-7.1 15.527-10.694 25.055-10.694a33.723 33.723 0 0117.09 4.478c3.406 1.938 8.786 6.4 11.471 8.77-.032-.064 9.315-9.182 9.315-9.182l-.934-1.051C76.507 5.378 64.336 0 50.25 0 36.219 0 24.211 4.859 14.557 14.443S-.001 35.599-.001 48.811c0 13.19 4.819 24.834 14.319 34.608 9.531 9.808 21.1 14.782 34.4 14.782h1.727c14.234 0 26.353-5.392 36.021-16.026l.986-1.085s-8.955-8.7-8.923-8.739a47.12 47.12 0 01-10.884 8.317zM662.861 2.009h17.831l31.393 94.184h-14.818l-7.409-23.735h-36.543l-7.536 23.735h-14.315zm-5.652 58.268h28.756L671.9 15.571h-.5zM490.436 23.882l-10.412 10.3a42.831 42.831 0 012.53 14.8c0 21.474-13.814 36.669-33.781 36.669s-33.78-15.194-33.78-36.669c0-21.223 13.814-36.669 33.78-36.669a32.973 32.973 0 0119.445 6l9.305-9.239A48.029 48.029 0 00448.772.011c-27.754 0-47.972 20.719-47.972 49.1s19.842 49.1 47.972 49.1c27.752 0 47.846-20.719 47.846-49.1a52.243 52.243 0 00-6.182-25.229zM147.01 57.513c13.689-3.14 22.73-13.812 22.73-27.376 0-15.947-12.934-28.255-31.019-28.255h-34.784v94.183h13.814V13.939h19.591c11.426 0 18.334 7.282 18.334 16.326 0 8.79-6.908 16.45-18.334 16.45h-12.1l6.828 11.678 22.728 37.673h15.949z"
            })
        ]
    }));
};


/***/ }),

/***/ 93659:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ stage_image_background; }
});

// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./node_modules/next/image.js
var next_image = __webpack_require__(25675);
var image_default = /*#__PURE__*/__webpack_require__.n(next_image);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
;// CONCATENATED MODULE: ./src/assets/default_header.jpg
/* harmony default export */ var default_header = ({"src":"/_next/static/media/default_header.e80958d5.jpg","height":775,"width":1920,"blurDataURL":"data:image/jpeg;base64,/9j/2wBDAAoHBwgHBgoICAgLCgoLDhgQDg0NDh0VFhEYIx8lJCIfIiEmKzcvJik0KSEiMEExNDk7Pj4+JS5ESUM8SDc9Pjv/2wBDAQoLCw4NDhwQEBw7KCIoOzs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozv/wAARCAADAAgDASIAAhEBAxEB/8QAFQABAQAAAAAAAAAAAAAAAAAAAAX/xAAcEAACAgIDAAAAAAAAAAAAAAABAgADBAURE9H/xAAVAQEBAAAAAAAAAAAAAAAAAAADBP/EABYRAAMAAAAAAAAAAAAAAAAAAAABMf/aAAwDAQACEQMRAD8AhbbNutDM60kgqOehPIiJSoE6f//Z"});
// EXTERNAL MODULE: ./src/utils/_hooks/useWindowSize.hook.ts
var useWindowSize_hook = __webpack_require__(29486);
// EXTERNAL MODULE: ./src/components/_shared/stage-image-background/stage-image-background.module.scss
var stage_image_background_module = __webpack_require__(48106);
var stage_image_background_module_default = /*#__PURE__*/__webpack_require__.n(stage_image_background_module);
;// CONCATENATED MODULE: ./src/components/_shared/stage-image-background/stage-image-background.tsx
function _arrayLikeToArray(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function _arrayWithHoles(arr) {
    if (Array.isArray(arr)) return arr;
}
function _iterableToArrayLimit(arr, i) {
    var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"];
    if (_i == null) return;
    var _arr = [];
    var _n = true;
    var _d = false;
    var _s, _e;
    try {
        for(_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true){
            _arr.push(_s.value);
            if (i && _arr.length === i) break;
        }
    } catch (err) {
        _d = true;
        _e = err;
    } finally{
        try {
            if (!_n && _i["return"] != null) _i["return"]();
        } finally{
            if (_d) throw _e;
        }
    }
    return _arr;
}
function _nonIterableRest() {
    throw new TypeError("Invalid attempt to destructure non-iterable instance.\\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function _slicedToArray(arr, i) {
    return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest();
}
function _unsupportedIterableToArray(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return _arrayLikeToArray(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(n);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen);
}






var StageImageBackground = function(props) {
    var ref = _slicedToArray((0,useWindowSize_hook/* default */.Z)(), 1), width = ref[0];
    var _url;
    return width ? /*#__PURE__*/ (0,jsx_runtime.jsx)((image_default()), {
        className: "".concat((stage_image_background_module_default())["stage-background"], " ").concat(props.className ? props.className : ""),
        src: (_url = props.url) !== null && _url !== void 0 ? _url : default_header.src,
        alt: props.alt,
        layout: "fill",
        sizes: width > 1920 ? "100vw" : "1920px",
        objectPosition: props.objectPosition,
        objectFit: "cover",
        priority: true
    }) : /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {});
};
/* harmony default export */ var stage_image_background = (StageImageBackground);
StageImageBackground.defaultProps = {
    objectPosition: "top"
};


/***/ }),

/***/ 58523:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "k": function() { return /* binding */ StageImageButtonToken; }
/* harmony export */ });
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(67294);
/* harmony import */ var _assets_creatoki_png__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(13692);
/* harmony import */ var _utils_enums_button_variants_enum__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(92212);
/* harmony import */ var _button_button__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(93217);
/* harmony import */ var _stage_image_button_token_module_scss__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(43067);
/* harmony import */ var _stage_image_button_token_module_scss__WEBPACK_IMPORTED_MODULE_6___default = /*#__PURE__*/__webpack_require__.n(_stage_image_button_token_module_scss__WEBPACK_IMPORTED_MODULE_6__);
/* harmony import */ var _link_link_base_link_base__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(27397);
function _defineProperty(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _defineProperty(target, key, source[key]);
        });
    }
    return target;
}
function _objectWithoutProperties(source, excluded) {
    if (source == null) return {};
    var target = _objectWithoutPropertiesLoose(source, excluded);
    var key, i;
    if (Object.getOwnPropertySymbols) {
        var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
        for(i = 0; i < sourceSymbolKeys.length; i++){
            key = sourceSymbolKeys[i];
            if (excluded.indexOf(key) >= 0) continue;
            if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
            target[key] = source[key];
        }
    }
    return target;
}
function _objectWithoutPropertiesLoose(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}







var StageImageButtonToken = function(_param) {
    var image = _param.image, editButtonProps = _param.editButtonProps, shadow = _param.shadow, props = _objectWithoutProperties(_param, [
        "image",
        "editButtonProps",
        "shadow"
    ]);
    var ref = (0,react__WEBPACK_IMPORTED_MODULE_1__.useState)(""), src = ref[0], setSrc = ref[1];
    (0,react__WEBPACK_IMPORTED_MODULE_1__.useEffect)(function() {
        setSrc("".concat(image, "?resolution=thumbnail"));
    }, [
        image
    ]);
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
        className: (_stage_image_button_token_module_scss__WEBPACK_IMPORTED_MODULE_6___default()["stage-image-button-token"]),
        children: [
            (props === null || props === void 0 ? void 0 : props.hasLink) ? /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_link_link_base_link_base__WEBPACK_IMPORTED_MODULE_5__/* .LinkBase */ .w, {
                className: (_stage_image_button_token_module_scss__WEBPACK_IMPORTED_MODULE_6___default()["stage-image-button-token-link"]),
                href: props.href,
                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_button_button__WEBPACK_IMPORTED_MODULE_4__/* .Button */ .z, _objectSpread({}, props, {
                    variant: shadow ? _utils_enums_button_variants_enum__WEBPACK_IMPORTED_MODULE_3__/* .ButtonVariantsEnum.STAGE */ .l.STAGE : _utils_enums_button_variants_enum__WEBPACK_IMPORTED_MODULE_3__/* .ButtonVariantsEnum.SECONDARY_FILLED */ .l.SECONDARY_FILLED,
                    className: (_stage_image_button_token_module_scss__WEBPACK_IMPORTED_MODULE_6___default()["token-button"]),
                    icon: {
                        element: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("img", {
                            src: src,
                            onError: function() {
                                return setSrc(_assets_creatoki_png__WEBPACK_IMPORTED_MODULE_2__/* ["default"].src */ .Z.src);
                            }
                        }),
                        align: "left"
                    },
                    buttonUrl: ""
                }))
            }) : /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_button_button__WEBPACK_IMPORTED_MODULE_4__/* .Button */ .z, _objectSpread({}, props, {
                variant: shadow ? _utils_enums_button_variants_enum__WEBPACK_IMPORTED_MODULE_3__/* .ButtonVariantsEnum.STAGE */ .l.STAGE : _utils_enums_button_variants_enum__WEBPACK_IMPORTED_MODULE_3__/* .ButtonVariantsEnum.SECONDARY_FILLED */ .l.SECONDARY_FILLED,
                className: (_stage_image_button_token_module_scss__WEBPACK_IMPORTED_MODULE_6___default()["token-button"]),
                icon: {
                    element: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("img", {
                        src: src,
                        onError: function() {
                            return setSrc(_assets_creatoki_png__WEBPACK_IMPORTED_MODULE_2__/* ["default"].src */ .Z.src);
                        }
                    }),
                    align: "left"
                },
                buttonUrl: ""
            })),
            editButtonProps && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_button_button__WEBPACK_IMPORTED_MODULE_4__/* .Button */ .z, _objectSpread({}, editButtonProps, {
                className: (_stage_image_button_token_module_scss__WEBPACK_IMPORTED_MODULE_6___default().editButton)
            }))
        ]
    });
};



/***/ }),

/***/ 70818:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "H": function() { return /* binding */ Stage; }
/* harmony export */ });
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var next_link__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(41664);
/* harmony import */ var next_link__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(next_link__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(67294);
/* harmony import */ var _assets_icons_creatoken_svg__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(43301);
/* harmony import */ var _utils_enums_alignment_enum__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(76221);
/* harmony import */ var _utils_enums_typeography_variants_enum__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(77872);
/* harmony import */ var _utils_helper_strapi_mapper__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(962);
/* harmony import */ var _button_button__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(93217);
/* harmony import */ var _link_link_base_link_base__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(27397);
/* harmony import */ var _stage_image_background_stage_image_background__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(93659);
/* harmony import */ var _typography_typography__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(28773);
/* harmony import */ var _stage_module_scss__WEBPACK_IMPORTED_MODULE_12__ = __webpack_require__(26160);
/* harmony import */ var _stage_module_scss__WEBPACK_IMPORTED_MODULE_12___default = /*#__PURE__*/__webpack_require__.n(_stage_module_scss__WEBPACK_IMPORTED_MODULE_12__);
/* harmony import */ var _stage_image_button_token_stage_image_button_token__WEBPACK_IMPORTED_MODULE_11__ = __webpack_require__(58523);
function _defineProperty(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _defineProperty(target, key, source[key]);
        });
    }
    return target;
}













var Stage = function(param) {
    var title = param.title, titleVariant = param.titleVariant, verticalOrientation = param.verticalOrientation, titleElement = param.titleElement, description = param.description, orientation = param.orientation, inverted = param.inverted, buttons = param.buttons, background = param.background, logo = param.logo, decButton = param.decButton, textDirection = param.textDirection, size = param.size, _className = param.className, className = _className === void 0 ? "" : _className;
    var ref3, ref1;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
        "data-testid": "stage",
        className: "".concat((_stage_module_scss__WEBPACK_IMPORTED_MODULE_12___default().stage), " ").concat((_stage_module_scss__WEBPACK_IMPORTED_MODULE_12___default())[size], " ").concat(className),
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_stage_image_background_stage_image_background__WEBPACK_IMPORTED_MODULE_9__/* ["default"] */ .Z, {
                url: background
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                children: [
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                        className: "".concat((_stage_module_scss__WEBPACK_IMPORTED_MODULE_12___default())[orientation], " ").concat(inverted ? (_stage_module_scss__WEBPACK_IMPORTED_MODULE_12___default().inverted) : "", " ").concat((_stage_module_scss__WEBPACK_IMPORTED_MODULE_12___default())["vert-".concat(verticalOrientation === null || verticalOrientation === void 0 ? void 0 : verticalOrientation.toLowerCase())]),
                        children: [
                            logo,
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                                className: textDirection === _utils_enums_alignment_enum__WEBPACK_IMPORTED_MODULE_4__/* .Alignment.HORIZONTAL */ .v.HORIZONTAL ? (_stage_module_scss__WEBPACK_IMPORTED_MODULE_12___default()["horizontal-text-alignment"]) : "",
                                children: [
                                    title && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                        className: (_stage_module_scss__WEBPACK_IMPORTED_MODULE_12___default().title),
                                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_typography_typography__WEBPACK_IMPORTED_MODULE_10__/* .Typography */ .Z, {
                                            className: textDirection === _utils_enums_alignment_enum__WEBPACK_IMPORTED_MODULE_4__/* .Alignment.HORIZONTAL */ .v.HORIZONTAL ? (_stage_module_scss__WEBPACK_IMPORTED_MODULE_12___default()["horizontal-text"]) : "",
                                            variant: titleVariant ? (0,_utils_helper_strapi_mapper__WEBPACK_IMPORTED_MODULE_6__/* .mapStrapiHeadline */ .z)(titleVariant) : _utils_enums_typeography_variants_enum__WEBPACK_IMPORTED_MODULE_5__/* .TypographyVariantsEnum.HEADING1 */ .H.HEADING1,
                                            element: titleElement ? titleElement : "h1",
                                            children: title
                                        })
                                    }),
                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                        className: textDirection === _utils_enums_alignment_enum__WEBPACK_IMPORTED_MODULE_4__/* .Alignment.HORIZONTAL */ .v.HORIZONTAL ? (_stage_module_scss__WEBPACK_IMPORTED_MODULE_12___default()["flex-container"]) : ""
                                    }),
                                    description && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                        className: (_stage_module_scss__WEBPACK_IMPORTED_MODULE_12___default().description),
                                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_typography_typography__WEBPACK_IMPORTED_MODULE_10__/* .Typography */ .Z, {
                                            variant: _utils_enums_typeography_variants_enum__WEBPACK_IMPORTED_MODULE_5__/* .TypographyVariantsEnum.INTROTEXT */ .H.INTROTEXT,
                                            children: description
                                        })
                                    })
                                ]
                            }),
                            buttons && buttons.length > 0 && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                className: (_stage_module_scss__WEBPACK_IMPORTED_MODULE_12___default().buttons),
                                children: buttons === null || buttons === void 0 ? void 0 : buttons.map(function(props) {
                                    var ref, ref2;
                                    if ((props === null || props === void 0 ? void 0 : props.buttonUrl) && (props === null || props === void 0 ? void 0 : props.external)) return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_link_link_base_link_base__WEBPACK_IMPORTED_MODULE_8__/* .LinkBase */ .w, {
                                        href: (ref = props === null || props === void 0 ? void 0 : props.buttonUrl) !== null && ref !== void 0 ? ref : "",
                                        external: props === null || props === void 0 ? void 0 : props.external,
                                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_button_button__WEBPACK_IMPORTED_MODULE_7__/* .Button */ .z, _objectSpread({
                                            inverted: inverted
                                        }, props))
                                    }, props.children);
                                    else if (props === null || props === void 0 ? void 0 : props.buttonUrl) return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)((next_link__WEBPACK_IMPORTED_MODULE_1___default()), {
                                        href: (ref2 = props === null || props === void 0 ? void 0 : props.buttonUrl) !== null && ref2 !== void 0 ? ref2 : "",
                                        passHref: true,
                                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("a", {
                                            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_button_button__WEBPACK_IMPORTED_MODULE_7__/* .Button */ .z, _objectSpread({
                                                inverted: inverted
                                            }, props))
                                        })
                                    }, props.children);
                                    else return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_button_button__WEBPACK_IMPORTED_MODULE_7__/* .Button */ .z, _objectSpread({
                                        inverted: inverted
                                    }, props));
                                })
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                        children: ((ref3 = decButton) === null || ref3 === void 0 ? void 0 : ref3.image) ? /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                            className: (_stage_module_scss__WEBPACK_IMPORTED_MODULE_12___default().decButtonCustomContainer),
                            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_stage_image_button_token_stage_image_button_token__WEBPACK_IMPORTED_MODULE_11__/* .StageImageButtonToken */ .k, _objectSpread({}, decButton, {
                                shadow: true
                            }))
                        }) : /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                            className: (_stage_module_scss__WEBPACK_IMPORTED_MODULE_12___default().decButtonContainer),
                            children: decButton === null || decButton === void 0 ? void 0 : (ref1 = decButton.icon) === null || ref1 === void 0 ? void 0 : ref1.element
                        })
                    })
                ]
            })
        ]
    });
};
Stage.defaultProps = {
    orientation: "CENTER",
    inverted: false,
    size: "Large",
    decButton: {
        icon: {
            element: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_assets_icons_creatoken_svg__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z, {}),
            align: "right"
        }
    },
    verticalOrientation: "CENTER"
};


/***/ }),

/***/ 48106:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"stage-background":"stage-image-background_stage-background__OC_4p"};

/***/ }),

/***/ 43067:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"stage-image-button-token":"stage-image-button-token_stage-image-button-token__NZS_U","stage-image-button-token-link":"stage-image-button-token_stage-image-button-token-link__aBRfn","editButton":"stage-image-button-token_editButton__E4dxD"};

/***/ }),

/***/ 26160:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"primary_accent":"#21547f","primary_lightAccent":"#3280bf","primary_dark":"#426dfd","primary_middleDark":"#42aaff","primary_middleLight":"#93bbd0","primary_light":"#dae3e5","greys_dark":"#000","greys_darkAccent":"#292929","greys_darkLight":"#333","greys_middleDark":"gray","greys_middle":"#858585","greys_middleLight":"#b3b3b3","greys_lightDark":"#f2f2f2","greys_lightAccent":"#eee","greys_light":"#fff","categoryColors_audio":"#fa4166","categoryColors_art":"#a2d902","categoryColors_eBook":"#1ce0c6","categoryColors_book":"#1ce0d6","signalColors_error":"red","signalColors_warning":"#f90","signalColors_success":"#11f49d","opacity_dark50":"rgba(0,0,0,.5)","opacity_dark10":"rgba(0,0,0,.1)","other_genreGreen":"#b5b124","desktop":"1366px","desktopSmall":"1024px","mobile":"576px","stage":"stage_stage__mWJSx","Large":"stage_Large__r40ds","Small":"stage_Small__ub55K","Left":"stage_Left__xOlFD","Right":"stage_Right__LnWA4","Center":"stage_Center__pBVue","vert-center":"stage_vert-center__1JjnW","vert-top":"stage_vert-top__HZCap","vert-bottom":"stage_vert-bottom__Narno","inverted":"stage_inverted__5pFbD","LEFT":"stage_LEFT__PidKd","CENTER":"stage_CENTER__IWvi4","RIGHT":"stage_RIGHT__h_mm5","decButtonContainer":"stage_decButtonContainer__4JP7K","decButtonCustomContainer":"stage_decButtonCustomContainer__dnItl","title":"stage_title__gG1nb","description":"stage_description__ZlSUN","horizontal-text-alignment":"stage_horizontal-text-alignment__9P2HF","horizontal-text":"stage_horizontal-text__KtwRO","flex-container":"stage_flex-container__MEEZy","buttons":"stage_buttons__L6Krm"};

/***/ })

}]);